'use client';

import React from 'react';

/**
 * Content wrapper for native auth pages.
 * The header is rendered by NativeAuthLayoutShell in the auth layout
 * so it persists across page navigations without flashing.
 * This component only handles the page content area (centered form).
 */
export function NativeAuthShell({
  children,
  logoUrl,
  accountName,
  appBackgroundColor,
  appTextColor,
}: {
  children: React.ReactNode;
  logoUrl?: string | null;
  accountName?: string;
  primaryColor: string;
  secondaryColor: string;
  appBackgroundColor?: string;
  appTextColor?: string;
  showBackButton?: boolean;
  onBack?: () => void;
}) {
  return (
    <div
      className="flex flex-1 flex-col items-center justify-center px-6"
      style={{
        backgroundColor: appBackgroundColor,
        color: appTextColor,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div className="w-full max-w-sm">
        {/* Logo */}
        {logoUrl && (
          <div className="mb-8 flex justify-center">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={logoUrl}
              alt={accountName ?? ''}
              className="h-16 w-auto object-contain"
              draggable={false}
            />
          </div>
        )}

        {children}
      </div>
    </div>
  );
}
